import { Trans, useTranslation } from 'react-i18next';

import { useUpdateAppSettings, useUser } from '~/api/user';
import { Alert, ExternalLink } from '~/components';
import { toast } from '~/utils/toast';
import { isItDeveloper } from '~/utils/user';

import { alertStyle } from './ComputerProgramAlert.css';

const knowledgeHubUrl = 'https://www.creativeshelter.be/knowledge-hub/auteursrechten-voor-iters-hoe-zit-dat-nu-precies';

export const ComputerProgramAlert = () => {
  const { data: user } = useUser();
  const mutation = useUpdateAppSettings();

  const { t } = useTranslation(['common', 'lines']);

  if (!isItDeveloper(user) || !user.appSettings.showComputerProgramAlert) return null;

  const onDismiss = () => {
    mutation.mutate(
      { appSettings: { showComputerProgramAlert: false } },
      { onError: () => toast.danger({ description: t('common:error') }) },
    );
  };

  return (
    <Alert announce className={alertStyle} dismissible icon="Info" onDismiss={onDismiss} status="info">
      <Trans components={{ faqLink: <ExternalLink href={knowledgeHubUrl} /> }} i18nKey="lines:computerProgramAlert" />
    </Alert>
  );
};
